module.exports = __webpack_public_path__ + "static/media/11.9573106e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shoes/11.png
// module id = 1508
// module chunks = 0